export default "__VITE_ASSET__BBT5hydq__"